export const APP_BAR_HEIGHT='60px';export const APP_BAR_HEIGHT_PADDED='72px';